import { IVoucherOrder } from '@epi-models/shared';

import createReducer from '../../helpers/CreateReducer';
import { ApiConstants } from '../../constants/actions';
interface VoucherOrdersResponse {
  voucherOrders: IVoucherOrder[];
  totalPages: number;
}

interface VoucherOrdersState {
  voucherOrders: IVoucherOrder[];
  totalPages: number;
  noPersistance: boolean;
  isError?: boolean;
}

interface ActionPayload {
  voucherOrdersResponse: VoucherOrdersResponse;
}

export const getInitialState = (): VoucherOrdersState => ({
  voucherOrders: [],
  totalPages: 1,
  noPersistance: true
});

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_VOUCHER_ORDERS_HISTORY}_SUCCESS`]: (
    state: VoucherOrdersState,
    { payload }: { payload: ActionPayload }
  ): VoucherOrdersState => ({
    ...state,
    voucherOrders: payload.voucherOrdersResponse.voucherOrders || [],
    totalPages: payload.voucherOrdersResponse.totalPages
  }),

  [`${ApiConstants.LOAD_VOUCHER_ORDERS_HISTORY}_FAILURE`]: (
    state: VoucherOrdersState
  ): VoucherOrdersState => ({
    ...state,
    voucherOrders: [],
    isError: true
  }),

  [`${ApiConstants.CLEAR_SAVED_HISTORY}`]: (
    state: VoucherOrdersState
  ): VoucherOrdersState => ({
    ...state,
    voucherOrders: [],
    isError: false
  })
});
